module.exports = __webpack_public_path__ + "static/p-logo--melcart-f94f6704bebd547561671642c08a6e50.png";